/* 劉備傳・第 8 章：雒城（214 年）
 * 雒城在北邊，方城、南面一座城門；劉備軍的營在南邊。 */
export const CITY = { x: 4000, y: 1700, hw: 1000, hh: 650 };
const T = 36, N = CITY.y - CITY.hh, S = CITY.y + CITY.hh, Wx = CITY.x - CITY.hw, E = CITY.x + CITY.hw;
export const GATE = [CITY.x, S], CAMP = [4000, 4200];
export default {
  id: 'luocheng', name: '雒城', W: 8000, H: 5000, seed: 214,
  bases: [CAMP, [CITY.x, CITY.y]],
  walls: [[CITY.x, N, CITY.hw + T, T], [Wx, CITY.y, T, CITY.hh], [E, CITY.y, T, CITY.hh], [(Wx + GATE[0] - 130) / 2, S, (GATE[0] - 130 - Wx) / 2 + T, T], [(GATE[0] + 130 + E) / 2, S, (E - GATE[0] - 130) / 2 + T, T]],
  roads: [{ pts: [CAMP, [4000, 3200], GATE, [CITY.x, CITY.y]], w: 150 }],
  rocks: [[1500, 3500, 420, 200], [6500, 3500, 420, 200], [1400, 1200, 360, 170], [6600, 1200, 360, 170]],
  woods: 0.4,
  sight: 0.8,
  clearings: [[CITY.x, CITY.y, 1100], [GATE[0], GATE[1] + 500, 600], [CAMP[0], CAMP[1], 500]],
  villages: [{ x: CITY.x, y: CITY.y - 100, n: 10, r: 600 }],
  tents: [{ x: CAMP[0], y: CAMP[1], n: 8, r: 440, chief: true, col: '#3e7b50', flag: '劉' }],
  fields: [[2600, 3400, 520, 260], [5400, 3300, 520, 260, '#86803f']],
};
